import { FC, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay } from 'swiper/core';
import { getNameByKey } from '../../../../../lib/utils/UtilsCommon';
import 'swiper/swiper.less';
import './style.less';

SwiperCore.use([Autoplay]);

interface IProps {
	classNames?: string;
}
/** 品牌报道 */
const BrandReport: FC<IProps> = ({ classNames }) => {
	const swipeRef = useRef(null);
	const list = [
		{
			channelImg: 'https://media.qianliaowang.com/xqd/tools/activity/image/2025112011/W97SAEB4-Q7YO-FV4S-1763626434861-NQY2PLRSYWMT.png?x-oss-process=image/format,webp',
			title: '银发兴趣教育如何定义“高质量”？兴趣岛荣获全国质量月质量诚信倡议企业',
			content: '2025年10月，在国家市场监督管理总局等26部门联合开展的全国“质量月”活动中，兴趣岛凭借在银发兴趣教育领域对师资筛选、课程研发与服务体系的全链条高质量把控，获得中国质量检验协会颁发的两项荣誉：“全国质量月质量诚信倡议企业” 和 “全国产品和服务质量诚信品牌”。',
			link: 'http://www.chinatt315.org.cn/rdgz/2025-11/11/257408.html',
		},
		{
			channelImg: 'https://media.qianliaowang.com/xqd/tools/activity/image/2025112011/2WUTG19V-2SEY-ST3F-1763622655956-EXDDTB2XMOPR.png?x-oss-process=image/format,webp',
			title: '重阳节，《乐龄族兴趣生活方式图鉴》广州发布',
			content: '2025年10月29日，重阳佳节，兴趣岛发布聚焦40-70岁人群兴趣生活的《乐龄族兴趣生活方式图鉴》，并同步揭牌成立兴趣生活研究院，获得人民日报记者关注报道。这份图鉴，通过平台超3500万用户的数据调研，描绘了当代乐龄群体突破年龄界限、通过兴趣学习重塑生活方式的新图景。',
			link: 'https://www.peopleapp.com/column/30050631310-500007173063',
		},
		{
			channelImg: 'https://media.qianliaowang.com/xqd/tools/activity/image/2025061211/SM4SIVHW-9B5M-LV7P-1749695996166-WJOWWOGYNQYK.png?x-oss-process=image/format,webp',
			title: '广州打造银发消费IP 与兴趣岛等领军企业共推银发经济发展',
			content: '6月3日，央级媒体消费日报发布报道，讲述兴趣岛受邀出席日前举办的广州首届银龄艺术季启动仪式暨天河区选拔赛，并助力本届艺术季举办。现场，兴趣岛副总裁林景接受广东电视台采访，天河区领导一行参观兴趣岛展台并进行工作指导。消费日报指出，兴趣岛与银龄艺术季的合作模式，已然成为推动银发经济发展的全新范式。',
			link: 'http://www.xfrb.com.cn/article/council/15291510638980.html',
		},
		{
			channelImg: 'https://img.qlchat.com/xqd/tools/activity/image/2025090211/E1POGY8Z-5ZLZ-DLEE-1756785374797-UAC63YZN5XSH.png',
			title: '满足高品质养老需求 业界打造全新兴趣生活体验',
			content: '8月28日，央媒人民网发布报道，讲述兴趣岛广州城市中心的落成，是兴趣岛从线上迈向线上线下融合发展的关键一步，更是对“让兴趣滋养生活”理念的重要践行。人民网指出，兴趣岛结合用户服务体验的洞察，打造“线上学习+线下参与”的一站式兴趣学习方式，把兴趣生活方式融入中老年日常，为中老年群体创造美好的精神生活。',
			link: 'http://finance.people.com.cn/n1/2025/0828/c1004-40552136.html',
		},
		{
			channelImg: 'https://media.qianliaowang.com/xqd/tools/activity/image/2025112011/EWIKGC7I-5EF6-NEKA-1763622663426-5U58ZBEJSTQW.png?x-oss-process=image/format,webp',
			title: '新消费图鉴 银发消费“上新” 服务供给加速升级',
			content: '2025年11月14日，中央广播电视总台CCTV-13《新闻直播间》聚焦中老年兴趣消费，深度解码了兴趣岛如何通过数字技术赋能兴趣学习，帮助银发族跨越 "数字鸿沟"，开启 "第二人生" 的精彩画卷。央视新闻的关注，既彰显了兴趣岛创新实践的行业价值，更印证了其“以用户为中心” 的核心理念，正与主流价值体系形成深度共鸣。',
			link: 'https://tv.cctv.com/2025/11/14/VIDEUAElS7GUbjzppUmqyRVr251114.shtml?spm=C53156045404.PKXC0xLPAnP9.0.0',
		},
		{
			channelImg: 'https://media.qianliaowang.com/qlLive/activity/image/MLOPCT67-GBK4-NWUO-1731044850458-CIQ5JIPXS6PS.png?x-oss-process=image/format,webp',
			title: '东方智慧与现代生活深度融合，兴趣岛武当太极蔚然成风',
			content: '10月30日，中宣部新华社《半月谈》发长文深度报道兴趣岛武当太极是东方智慧与现代生活深度融合，据悉，《半月谈》被誉为"中华第一刊"，是中宣部委托新华社主办的重要党刊，本报道对于兴趣岛媒体传播极具影响力。',
			link: 'https://mp.weixin.qq.com/s/Dc6zZ_Nma7hhxnLwMv65DQ',
		},
		{
			channelImg: 'https://media.qianliaowang.com/qlLive/activity/image/DL9LWEBE-WNBD-16DV-1743676374320-U8UCR3AIZRO5.png?x-oss-process=image/format,webp',
			title: '2025兴趣岛艺术节启幕，深耕银龄文化服务探索"第二人生"无限精彩',
			content: '3月28日，央级媒体中国日报网发布报道，讲述2025兴趣岛艺术节现场盛况，聚焦兴趣岛名师更多，指出兴趣岛组建名师团队，通过高质量的专业教学，帮助银龄群体在多个艺术兴趣领域突破自我。',
			link: 'https://cnews.chinadaily.com.cn/a/202503/28/WS67e6384aa31008317a2af1b4.html',
		},
		// {
		// 	channelImg: 'https://media.qianliaowang.com/xqd/tools/activity/image/2025112011/JK1MDJ7Z-FYJV-D3JB-1763626382821-4VDVVG3ZLCV9.png?x-oss-process=image/format,webp',
		// 	title: '广州上百人登山练太极，“文化+游学”受关注',
		// 	content: '9月19日，央级媒体新华网发布报道，讲述兴趣岛武当太极游学活动盛况，及其对响应国家号召弘扬中国传统文化的意义。',
		// 	link: 'https://app.xinhuanet.com/news/article.html?articleId=2f0eb7588363f1bdc0175cbdd4340640&timestamp=88759',
		// },
		// {
		// 	channelImg: 'https://img.qlchat.com/qlLive/activity/image/EIAY848U-7ZO3-VWHU-1715420664347-5D6TM1XE6D35.png?x-oss-process=image/format,webp',
		// 	title: '兴趣岛亮相2024广州文交会，共同构建多领域创新发展新格局',
		// 	content: '9月27日-29日，2024广州文化产业交易会在广交会展馆举办。期间，兴趣岛展出企业如何通过中华优秀传统文化激发银发一族的兴趣文化空间，并荣获2024年“广州文化企业30强”称号。',
		// 	link: 'http://news.china.com.cn/mts/2024-10/08/content_1195793.htm',
		// },
		// {
		// 	channelImg: 'https://media.qianliaowang.com/qlLive/activity/image/FP6VEO4D-ZVAW-TIP8-1731044852473-QQ9DOL5QHH4Z.png?x-oss-process=image/format,webp',
		// 	title: '兴趣岛受邀参加2024中国数字文娱大会',
		// 	content: '今年8月，2024年中国数字文娱大会在广州市天河区开幕，' + getNameByKey('comp') + '（以下简称兴趣岛）受邀参加，体现了文娱行业和政府单位对兴趣岛创新实力和行业影响力的认可。',
		// 	link: 'https://app.ceweekly.cn/h5/#/pages/detail/articleDetail/articleDetail?id=453025&share=1',
		// },
		// {
		// 	channelImg: 'https://media.qianliaowang.com/qlLive/activity/image/4731W64J-5PRQ-IAWU-1731044854422-NBBA1F1Y211S.png?x-oss-process=image/format,webp',
		// 	title: '兴趣岛终南山武当太极活动：边游边学，让更多人感受太极之美',
		// 	content: '10月18日，兴趣岛武当太极终南山站“强身心溯文化共作武当太极传承人”活动今年已举办第三次，本次活动带领近百位银龄人群感受武当太极非遗之美，被国家文旅部直属媒体《文旅中国》深度报道并高度评价本次活动让传统武术有了新的“打开方式”。',
		// 	link: 'https://share.ccmapp.cn/shareDetail?1=1&action=opendetail%3Brichtext%3B671e0bdc56be8b58b018b24e&siteId=2',
		// },

		// {
		// 	channelImg: 'https://img.qlchat.com/xqd/tools/activity/image/2025090211/4A7A1FL9-PP2D-G8DZ-1756794914980-421SQHDFNOS8.png',
		// 	title: '银发经济观察丨兴趣岛：用“创新+标准”构建在线兴趣学习行业标杆',
		// 	content: '8月26日，国内消费经济领域中唯一全国性综合日报《消费日报》发布报道，讲述兴趣岛受邀参展第九届中国（广州）国际养老健康产业博览会，凭借“创新+标准”构建在线兴趣学习行业标杆，荣获大会双项大奖。消费日报指出，兴趣岛为用户提供丰富精神文化生活的服务同时，持续发挥行业影响力，共同构建更健康、安全、有保障的标准化服务，让银发群体在提升自身生活幸福感、提振消费信心。',
		// 	link: 'https://mp.weixin.qq.com/s/mgL4eIrwYyOoh-r0uaDl3Q',
		// },
		{
			channelImg: 'https://media.qianliaowang.com/xqd/tools/activity/image/2026013011/LWGG3T3B-ILYQ-NSLY-1769766325786-FPEUXMUQPFZ1.png',
			title: '央视新闻关注兴趣岛 兴趣岛成行业实践样本',
			content: '广州兴趣岛信息科技有限公司联合创始人刘艺：我们企业自成立以来已研发30门视频课程，在线学员达3500万人。咨询情况来看，摄影、瑜伽、太极等课程备受老年用户青睐。',
			link: 'https://content-static.cctvnews.cctv.com/snow-book/index.html?item_id=17107754974317665045&toc_style_id=feeds_default&track_id=3A35A166-53BB-4B84-A911-319EC956A5F9_784795121525&share_to=wechat',
		},
		{
			channelImg: 'https://media.qianliaowang.com/xqd/tools/activity/image/2026013011/GVJYIL2R-KQU7-FJZM-1769763842232-7T34BEHXO6CL.png',
			title: '兴趣岛“三师”服务模式 守护银发族学习梦',
			content: '兴趣岛创新推出“三师”服务模式，通过名师授课、助教点评、班主任陪伴答疑，构建出一个全方位的学习支持闭环。名师传授专业知识，助教跟踪学习效果、指导技能提升，班主任则负责日常鼓励、情感支持和学习督促——三者协同，为中老年学员提供全程陪伴。',
			link: 'http://www.cctvzyzg.com/index/detail/id/8882.html',
		},
		{
			channelImg: 'https://media.qianliaowang.com/xqd/tools/activity/image/2026013011/CPJWJ4X5-M5CU-HZWA-1769764014901-BY1ANGQ242XY.png',
			title: '中老年兴趣学习升温 业界助力构建行业良性生态',
			content: '兴趣岛副总裁林景在近日举办的第三届消费大赏活动现场提及此现状时表示，作为在线学习平台，兴趣岛对外发布在线兴趣教育服务标准——“九不做”，以规范化举措构建健康的兴趣学习生态。',
			link: 'http://finance.people.com.cn/n1/2025/0704/c1004-40515091.html',
		},
		{
			channelImg: 'https://media.qianliaowang.com/xqd/tools/activity/image/2026013011/K6RPUN7G-PYGQ-57NE-1769764220469-KGRPOBIR36HZ.png',
			title: '兴趣岛爱心图书室落地四川箭板小学 点亮孩子们的阅读梦',
			content: '2025年12月，广州兴趣岛信息科技有限公司向四川省沐川县箭板小学捐赠2763册涵盖文学、科普、童话等类别的优质图书，有效改善了该校阅读资源不足的困境。',
			link: 'http://gd.news.cn/20251224/06b7898a5a384c07b71d1d2ce867064c/c.html',
		},
		{
			channelImg: 'https://media.qianliaowang.com/xqd/tools/activity/image/2026013011/GXIZAKZN-7XHP-PEFH-1769764288216-RP9ML2XZ5G9N.png',
			title: '从线上课堂到专业舞台的产业实践 师生音乐会解锁银发经济新路径',
			content: '2026年1月16日晚，广州南越SYNT演艺中心温情涌动，随着一曲《难忘今宵》的合唱旋律缓缓落下，为期3天的兴趣岛“圆梦时光・宋伶俐新年师生音乐会”圆满落幕。50余位乐龄歌者与兴趣岛唱歌特训营首席讲师、中央民族乐团女中音歌唱家、国家一级演员宋伶俐老师同台献艺，用饱含热爱的歌声，完成了一场从线上课堂到线下舞台的圆梦之约，这是兴趣岛联合兴趣生活研究院打造的专业舞台展演活动。',
			link: 'https://m.itouchtv.cn/video/7d7ea08914e3a170b330bb4d74729119?shareId=VicjEQdE',
		},
		{
			channelImg: 'https://media.qianliaowang.com/xqd/tools/activity/image/2026013011/34CSES3W-5KI8-QUS7-1769764336120-5LNBY8DX1K8R.png',
			title: '兴趣岛发起“i公益志愿服务计划” 以“研究 + 公益”推动乐龄兴趣文化普惠',
			content: '2025 年 10 月 28 日，“2025 广州银龄艺术季颁奖典礼暨优秀节目展演” 在广州粤剧院举行。活动现场，由广州兴趣岛信息科技有限公司直接管理的兴趣岛i公益志愿服务队牵头的 “i公益志愿服务计划” 正式发布，这标志兴趣学习平台兴趣岛将企业社会责任与核心战略深度绑定，以兴趣普惠为核心，精准聚焦老年群体关怀领域。',
			link: 'https://biznews.sohu.com/a/950482469_121198369',
		},
		{
			channelImg: 'https://media.qianliaowang.com/xqd/tools/activity/image/2026013011/67RFPKDQ-ITMU-D5N3-1769774726951-2SM6W36D5RCQ.png',
			title: '引领行业消费保障新标准，兴趣岛推出“48小时自动退费”服务升级',
			content: '兴趣岛作为行业领先的在线兴趣学习品牌，此前发布《在线兴趣学习“九不做”服务倡议》，明确提出九项具体、可执行的服务规范，树立行业自律标杆。2025年9月，其App面向购买体验课程用户的“48小时自动退费”功能正式上线，率先在行业内实现退费自动化，引发广泛关注。',
			link: 'https://caijing.chinadaily.com.cn/a/202509/10/WS68c1364ba310f07257747b62.html',
		},
		{
			channelImg: 'https://media.qianliaowang.com/xqd/tools/activity/image/2026013011/67RFPKDQ-ITMU-D5N3-1769774726951-2SM6W36D5RCQ.png',
			title: '兴趣岛多维升级员工关怀计划，“以人为本”打造有温度雇主品牌',
			content: '2025年9月，国内在线兴趣学习头部品牌兴趣岛正式宣布，其内部员工福利项目——“爱心慰助关怀计划”全面升级至2.0版本。该计划自今年3月启动1.0版本以来，公司划拨专款，累计已帮扶6位因疾病导致困难的员工，切实体现了企业对员工的坚实支持。',
			link: 'https://caijing.chinadaily.com.cn/a/202509/12/WS68c3be9fa310f0725774817b.html',
		},
		{
			channelImg: 'https://media.qianliaowang.com/xqd/tools/activity/image/2026013011/C2OJJEDY-DM7O-8OCH-1769772957670-4S4W8YJ5CHJ1.png',
			title: '《乐龄族兴趣生活方式图鉴》揭示“无龄感”生活新趋势',
			content: '2025年10月29日，一份聚焦40-70岁人群兴趣生活的《乐龄族兴趣生活方式图鉴》（下称《图鉴》）在广州发布。这份由大成人在线兴趣学习平台兴趣岛编制的图鉴，通过超3500万用户的数据调研，描绘了当代乐龄群体突破年龄界限、通过兴趣学习重塑生活方式的新图景。',
			link: 'https://app.gmdaily.cn/as/opened/n/f939e15199ad437ca2d909fcd7f259a6',
		},
		{
			channelImg: 'https://media.qianliaowang.com/xqd/tools/activity/image/2026013011/JS9TAZVF-T5QX-P14I-1769764615383-U1TJSKN1NBBL.png',
			title: '50多位银发歌者与国家一级演员宋伶俐同台圆梦',
			content: '为期三天的兴趣岛“圆梦时光·宋伶俐新年师生音乐会”16日晚在广州南越SYNT演艺中心圆满落幕。当晚，50余位乐龄歌者与兴趣岛唱歌特训营首席讲师、中央民族乐团女中音歌唱家、国家一级演员宋伶俐同台献艺，用歌声完成了一场从线上课堂到线下舞台的圆梦之约。',
			link: 'https://www.gd.chinanews.com.cn/2026/2026-01-20/446204.shtml',
		},
	];

	const onSlidePrev = () => {
		swipeRef.current?.slidePrev?.();
	};

	const onSlideNext = () => {
		swipeRef.current?.slideNext?.();
	};

	const changeAutoPlay = () => {
		if (!swipeRef.current.autoplay.running) {
			swipeRef.current.autoplay?.start?.();
		} else {
			swipeRef.current.autoplay?.stop?.();
		}
	};

	const getSwipeInstance = (swiper) => {
		swipeRef.current = swiper;
	};

	return (
		<div className={`home-brand-report-container ${classNames}`}>
			<div className="brand-report-list">
				<div className="brand-report-prev flex-center" onClick={onSlidePrev}>
					<i className="iconfont iconxiaojiantou to-left"></i>
				</div>
				<div className="brand-report-next flex-center" onClick={onSlideNext}>
					<i className="iconfont iconxiaojiantou"></i>
				</div>
				<Swiper
					onSwiper={getSwipeInstance}
					// navigation={true}
					slidesPerView="auto"
					loop={true}
					observer
					observeParents
					observeSlideChildren
					centeredSlides
					spaceBetween={48}
					autoplay={{
						delay: 5000,
						disableOnInteraction: false,
					}}
					className="brand-report-swiper">
					{list.map((item: any, index: number): any => (
						<SwiperSlide key={index} className="brand-report-slide">
							<div className="brand-report-item" key={index} onMouseOver={changeAutoPlay} onMouseOut={changeAutoPlay} onClick={() => window.open(item?.link)}>
								<div className="report-item-wrap">
									<img className="channel-img" src={item.channelImg} />
									<div className="title">{item.title}</div>
									<div className="content">{item.content}</div>
								</div>
								<div className="view-detail-text flex-center">
									查看详情
									<i className="iconfont iconxiaojiantou"></i>
								</div>
							</div>
						</SwiperSlide>
					))}
				</Swiper>
			</div>
		</div>
	);
};
export default BrandReport;
